import { GAME_SIZE_IDS, type GameSizeId } from '@brig/rules-engine';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import * as styles from './SizePicker.css.ts';

/** The size of a new game: map, forts and the fixed fleet all follow from it (R-SIZE-*). */
export function SizePicker({
  value,
  onChange,
  sizes = GAME_SIZE_IDS,
}: {
  value: GameSizeId;
  onChange: (size: GameSizeId) => void;
  /** The sizes on offer; every size by default. */
  sizes?: readonly GameSizeId[];
}) {
  const { t } = useTranslation();
  const name = useId();
  const ids = (id: GameSizeId) => ({ label: `${name}-${id}`, detail: `${name}-${id}-detail` });
  return (
    <fieldset className={styles.picker}>
      <legend className={styles.legend}>{t('game.size.label')}</legend>
      {sizes.map((id) => (
        <label key={id} className={styles.option}>
          <input
            type="radio"
            className={styles.radio}
            name={name}
            value={id}
            checked={value === id}
            aria-labelledby={ids(id).label}
            aria-describedby={ids(id).detail}
            onChange={() => {
              onChange(id);
            }}
          />
          <span id={ids(id).label} className={styles.name}>
            {t(`game.size.${id}.name`)}
          </span>
          <span id={ids(id).detail} className={styles.detail}>
            <span className={styles.counts}>{t(`game.size.${id}.counts`)}</span>{' '}
            <span className={styles.blurb}>{t(`game.size.${id}.blurb`)}</span>
          </span>
        </label>
      ))}
    </fieldset>
  );
}
